<template>
    <div class="inner-custom-tab">
        <a :href="`/developer/${projectId}/add-project-step2?type=house`" class="general-btn positive-btn floating-topright-btn" v-if="canManage">
            <span> Adauga Model </span>
        </a>
        <div class="pdetail-levels-container levels-container">
            <div class="single-level-wrapper" v-for="(house, key) in  models" :key="key">
                <div class="single-item-headingstrip mb-2" v-if="canManage">
                    <h3> {{ findRoomCountNameById(house.rooms_count_id) }} {{ house.model_type }} </h3>
                    <div class="single-item-actions">
                        <a :href="`/developer/${house.project_id}/model/${house.id}/edit`"
                            class="general-btn positive-btn">
                            <span> Modifica Model </span>
                        </a>
                        <a @click="addItemToModel(house)"
                            class="general-btn positive-btn">
                            <span> Adauga disponibilitati </span>
                        </a>
                        <a href="javascript:void(0)"
                           @click="deleteModel(house.id)"
                           class="general-btn positive-btn">
                            <span> Sterge Model </span>
                        </a>
                    </div>
                </div>
                <div class="pdetails-houses-container">
                    <div class="single-level-row pdetail-level-row" v-for="(item, key) in  house.items" :key="key" :class="(item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available')">
                        <div class="row" :id="`item_${item.id}`">
                            <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12">
                                <div class="level-item-nr level-strip-cell">
                                    <p class="level-cell-heading"> Nr. Casa </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ item.apartment_number }} </p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="apartment_number" v-model="editableItems[item.id].apartment_number">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                <div class="level-item-nr level-strip-cell">
                                    <p class="level-cell-heading"> Finalizata la data </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ item.finalized_at ? item.finalized_at : '--' }} </p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="finalized_at" v-model="editableItems[item.id].finalized_at">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mb-1">
                                <p class="level-cell-heading"> Suprafata</p>
                                <div class="level-item-size level-strip-cell pdetail-level-cell pdetail-level-cell--column">
                                    <div class="pdetail-surface-type">
                                        <span> Totala: </span>
                                        <span v-if="!isItemInEditMode(item.id)"> {{ item.useful_surface }} (m²)</span>
                                        <div class="input-container" v-if="isItemInEditMode(item.id)">
                                            <div class="input-group mg-b">
                                                <input type="number" class="useful_surface" v-model="editableItems[item.id].useful_surface">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pdetail-surface-type">
                                        <span> Teren: </span>
                                        <span v-if="!isItemInEditMode(item.id)"> {{ item.garden_surface }} (m²)</span>
                                        <div class="input-container" v-if="isItemInEditMode(item.id)">
                                            <div class="input-group mg-b">
                                                <input type="number" class="garden_surface" v-model="editableItems[item.id].garden_surface">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pdetail-surface-type">
                                        <span> Balcon: </span>
                                        <span v-if="!isItemInEditMode(item.id)"> {{ item.terrace_surface }} (m²)</span>
                                        <div class="input-container" v-if="isItemInEditMode(item.id)">
                                            <div class="input-group mg-b">
                                                <input type="number" class="terrace_surface" v-model="editableItems[item.id].terrace_surface">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Pret (EUR) </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ itemPrices[item.id] }} ({{ itemPricesWithVat[item.id] ? 'TVA inclus' : '+TVA' }})</p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="price" v-model="editableItems[item.id].price">
                                        </div>
                                    </div>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group mg-b">
                                            <select class="status" v-model="editableItems[item.id].price_with_vat">
                                                <option value="0"> +TVA </option>
                                                <option value="1"> TVA Inclus </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                <div class="level-item-size level-strip-cell">
                                    <p class="level-cell-heading"> Pret cu credit (EUR) </p>
                                    <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id) && item.credit_price"> {{ itemCreditPrices[item.id] }} ({{ itemCreditPricesWithVat[item.id] ? 'TVA inclus' : '+TVA' }}) </p>
                                    <p class="highlighted-info-strip" v-else-if="!isItemInEditMode(item.id)"> -- </p>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group">
                                            <input type="text" class="credit_price" v-model="editableItems[item.id].credit_price">
                                        </div>
                                    </div>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group mg-b">
                                            <select class="status" v-model="editableItems[item.id].credit_price_with_vat">
                                                <option value="0"> +TVA </option>
                                                <option value="1"> TVA Inclus </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12 col-12 mb-1">
                                <div class="level-item-size level-strip-cell">
                                    <div class="level-cell-heading level-cell-heading--status" v-if="!isItemInEditMode(item.id) && item.status === 'available'" style="display: flex;"> Status <span class="highlighted-info-strip"> Disponibil</span></div>
                                    <div class="level-cell-heading level-cell-heading--status" v-if="!isItemInEditMode(item.id) && item.status === 'reserved'" style="display: flex;"> Status <span class="highlighted-info-strip"> Rezervat</span></div>
                                    <div class="level-cell-heading level-cell-heading--status" v-if="!isItemInEditMode(item.id) && item.status === 'sold'" style="display: flex;"> Status <span class="highlighted-info-strip"> Vandut</span></div>
                                    <div class="input-container" v-if="isItemInEditMode(item.id)">
                                        <div class="input-group mg-b">
                                            <select class="status" v-model="editableItems[item.id].status">
                                                <option value="available"> Disponibil</option>
                                                <option value="reserved"> Rezervat</option>
                                                <option value="sold"> Vandut</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                <div class="level-strip-cell">
                                    <div class="list-item-actions">
                                        <a href="javascript:void(0)"
                                           @click="openItemDetailModal(item.id,canManage)"
                                           class="item-action-btn"
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           title="Vezi Detalii"
                                        >
                                            <i class="fad fa-eye"></i>
                                        </a>
                                        <a href="javascript:void(0)"
                                           v-if="canManage"
                                           @click="openEditInlineModelItem(item)"
                                           class="item-action-btn"
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           title="Modifica Casa"
                                        >
                                            <i class="fad fa-edit"></i>
                                        </a>
                                        <a href="javascript:void(0)"
                                           v-if="canManage"
                                           @click="deleteItem(item)"
                                           class="item-action-btn"
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           title="Sterge Casa"
                                        >
                                            <i class="fad fa-trash-alt"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="level-strip-cell level-strip-cell--edit" v-if="isItemInEditMode(item.id)">
                                    <div class="list-item-actions list-item-actions--edit">
                                        <a href="javascript:void(0)"
                                           @click="cancelEditInlineModelItem(item)"
                                           class="developer-list-edit-button developer-list-edit-button--cancel"
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           title="Anulează modificările"
                                        >
                                            Anulează
                                        </a>
                                        <a href="javascript:void(0)"
                                           @click="saveInlineModelItem(item.id)"
                                           v-if="canManage"
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           title="Salvează modificările"
                                           class="developer-list-edit-button"
                                        >
                                            Salvează
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <developer-edit-house-items/>
        </div>
    </div>
</template>

<script>
    import DeveloperEditHouseItems from "./DeveloperEditHouseItems";
    export default {
        name: "DeveloperListHouses",
        props: ['projectId', 'roomsCountList','canManage'],
        components: {
            DeveloperEditHouseItems
            // editor
        },
        data() {
            return {
                models: [],
                housesKey: 1,
                inlineEditItems: [],
                newItemId: -1,
            }
        },
        async mounted() {
            let vm = this
            await this.getHousesData()
            this.$eventBus.$on('MODEL_ITEMS_CHANGED', function () {
                vm.getHousesData()
            });
            this.$eventBus.$on('CLIENT_ASSIGNED', function () {
                vm.getHousesData()
            });
            this.$eventBus.$on('ITEM_DETAIL_SAVED', function () {
                vm.getHousesData()
            });
        },
        computed: {
            editableItems() {
                let items = [];
                this.inlineEditItems.forEach(function (item){
                    items[item.id] = item;
                })
                return items;
            },
            itemPrices() {
                let vm = this;
                let prices = [];
                for(let i in vm.models) {
                    vm.models[i].items.forEach(function (item) {
                        prices[item.id] = vm.formatPrice(item.price, false);
                    });
                }
                return prices;
            },
            itemPricesWithVat() {
                let vm = this;
                let result = [];
                for(let i in vm.models) {
                    vm.models[i].items.forEach(function (item) {
                        result[item.id] = item.price_with_vat;
                    });
                }
                return result;
            },
            itemCreditPrices() {
                let vm = this;
                let prices = [];
                for(let i in vm.models) {
                    vm.models[i].items.forEach(function (item) {
                        prices[item.id] = vm.formatPrice(item.credit_price, false);
                    });
                }
                return prices;
            },
            itemCreditPricesWithVat() {
                let vm = this;
                let result = [];
                for(let i in vm.models) {
                    vm.models[i].items.forEach(function (item) {
                        result[item.id] = item.credit_price_with_vat;
                    });
                }
                return result;
            },
        },
        methods: {
            triggerEditItem(itemId, modelId) {
                this.$refs.editHouseItemModal.getModelData(itemId, modelId)
            },
            getHousesData() {
                let vm = this
                window.axios.get(`/ajax/developer/get-models-with-items/${this.projectId}/house`)
                    .then(function (resp) {
                        vm.models = resp.data.data
                    })
                    .catch(function (err) {
                        window.showError(err)
                    });
            },
            findRoomCountNameById(id) {
                const room = this.roomsCountList.find(element => element.id == id);
                if (room) {
                    return room.name
                } else {
                    return ''
                }
            },
            openEditInlineModelItem(item) {
                let clone = Object.assign({}, item);
                this.inlineEditItems.push(clone);
            },
            cancelEditInlineModelItem(item) {
                this.inlineEditItems = this.inlineEditItems.filter(editItem => item.id != editItem.id);

                // if item is added inline
                if(item.id < 0) {
                    let building = this.buildings.find(b => b.id === item.project_building_id);
                    // delete row and "reload"
                    this.reloadLevelId = item.level_id;
                    for (let i = 0; i < building.items.length; i++) {
                        if (building.items[i].id === item.id) {
                            building.items.splice(i, 1);
                        }
                    }
                    this.setBuildingsFilter(building);
                    this.reloadLevelId = null;
                }
            },
            isItemInEditMode(itemId) {
                return this.inlineEditItems.find(item => item.id == itemId);
            },
            saveInlineModelItem(itemId) {
                let vm = this;
                let isAddAction = itemId < 0;
                let editedItem = this.editableItems[itemId];
                if(!editedItem) {
                    window.showError('Item invalid');
                    return;
                }

                let houseNumber = editedItem.apartment_number ? editedItem.apartment_number+'' : '';
                let usefulSurface = editedItem.useful_surface ? editedItem.useful_surface+'' : '';
                let gardenSurface = editedItem.garden_surface ? editedItem.garden_surface+'' : '';
                let terraceSurface = editedItem.terrace_surface ? editedItem.terrace_surface+'' : '';
                let price = editedItem.price ? editedItem.price+'' : '';
                let priceWithVat = editedItem.price_with_vat ? editedItem.price_with_vat+'' : '';
                let creditPrice = editedItem.credit_price ? editedItem.credit_price+'' : '';
                let creditPriceWithVat = editedItem.credit_price_with_vat ? editedItem.credit_price_with_vat+'' : '';
                let status = editedItem.status ? editedItem.status+'' : '';
                let finalizedAt = editedItem.finalized_at ? editedItem.finalized_at+'' : '';

                let formData = new FormData();
                formData.append('houseNumber', houseNumber);
                formData.append('usefulSurface', usefulSurface);
                formData.append('gardenSurface', gardenSurface);
                formData.append('terraceSurface', terraceSurface);
                formData.append('price', price);
                formData.append('priceWithVat', priceWithVat);
                formData.append('creditPrice', creditPrice);
                formData.append('creditPriceWithVat', creditPriceWithVat);
                formData.append('status', status);
                formData.append('finalizedAt', finalizedAt);

                if(isAddAction) {
                    window.axios.post('/developer/' + this.projectId + '/house/' + editedItem.project_model_id + '/add-item', formData)
                        .then(function (response) {
                            let html = ''
                            if (response.data.data.type === 'apartment') {
                                html = "Apartamentul a fost adaugat cu succes."
                            } else if (response.data.data.type === 'house') {
                                html = "Casa a fost adaugata cu succes."
                            } else if (response.data.data.type === 'commercial') {
                                html = "Spatiul comercial a fost adaugat cu succes."
                            }

                            for (let m in vm.models) {
                                for (let i = 0; i < vm.models[m].items.length; i++) {
                                    if (vm.models[m].items[i].id === editedItem.id) {
                                        vm.models[m].items[i].id = response.data.data.id;
                                        vm.models[m].items[i].apartment_number = response.data.data.apartment_number;
                                        vm.models[m].items[i].useful_surface = response.data.data.useful_surface;
                                        vm.models[m].items[i].garden_surface = response.data.data.garden_surface;
                                        vm.models[m].items[i].terrace_surface = response.data.data.terrace_surface;
                                        vm.models[m].items[i].price = response.data.data.price;
                                        vm.models[m].items[i].price_with_vat = response.data.data.price_with_vat;
                                        vm.models[m].items[i].credit_price = response.data.data.credit_price;
                                        vm.models[m].items[i].credit_price_with_vat = response.data.data.credit_price_with_vat;
                                        vm.models[m].items[i].status = response.data.data.status;
                                        vm.models[m].items[i].finalized_at = response.data.data.finalized_at;
                                    }
                                }
                            }

                            vm.cancelEditInlineModelItem(editedItem);

                            window.Swal.fire({
                                html: html,
                                icon: 'success',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            })
                        })
                        .catch(function (err) {
                            window.showError(err);
                            let isValidationError = err.response && err.response.status == 422;
                            if(!isValidationError) {
                                // force reload to prevent data inconsistency
                                setTimeout(function(){ window.location.reload(); }, 5000);
                            }
                        });
                } else {
                    window.axios.post('/developer/' + this.projectId + '/house/' + editedItem.project_model_id + '/item/' + itemId + '/edit', formData)
                        .then(function (response) {
                            let html = ''
                            if (response.data.data.type === 'apartment') {
                                html = "Apartamentul a fost modificat cu succes."
                            } else if (response.data.data.type === 'house') {
                                html = "Casa a fost modificata cu succes."
                            } else if (response.data.data.type === 'commercial') {
                                html = "Spatiul comercial a fost modificat cu succes."
                            }

                            for (let i in vm.models) {
                                vm.models[i].items.forEach(function (item) {
                                    if (item.id == response.data.data.id) {
                                        item.apartment_number = response.data.data.apartment_number;
                                        item.useful_surface = response.data.data.useful_surface;
                                        item.garden_surface = response.data.data.garden_surface;
                                        item.terrace_surface = response.data.data.terrace_surface;
                                        item.price = response.data.data.price;
                                        item.price_with_vat = response.data.data.price_with_vat;
                                        item.credit_price = response.data.data.credit_price;
                                        item.credit_price_with_vat = response.data.data.credit_price_with_vat;
                                        item.status = response.data.data.status;
                                        item.finalized_at = response.data.data.finalized_at;
                                        vm.cancelEditInlineModelItem(item);
                                    }
                                })
                            }

                            window.Swal.fire({
                                html: html,
                                icon: 'success',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            })
                        })
                        .catch(function (err) {
                            window.showError(err)
                        });
                }
            },
            addItemToModel(model) {
                let item = {
                    advance_amount: null,
                    apartment_number: null,
                    client: null,
                    client_id: null,
                    created_at: null,
                    credit_price: model.credit_price,
                    credit_price_with_vat: model.credit_price_with_vat,
                    deleted_at: null,
                    final_price: null,
                    finalized_at: null,
                    garden_surface: model.garden_surface,
                    id: this.newItemId,
                    level: null,
                    level_id: null,
                    model: model,
                    notes: null,
                    price: model.price,
                    price_with_vat: model.price_with_vat,
                    project_building_id: null,
                    project_id: model.project_id,
                    project_model_id: model.id,
                    show_status_for_agencies: 0,
                    show_status_for_clients: 0,
                    status: 'available',
                    terrace_surface: model.terrace_surface,
                    type: model.type,
                    updated_at: null,
                    useful_surface: model.useful_surface,
                };
                this.newItemId--;

                model.items.push(item);

                // inline edit form
                this.openEditInlineModelItem(item);
            },
        }
    }
</script>
